<template>
	<form @submit.prevent="onFormSubmitted">
		<div class="flex flex-wrap mb-6">
			<fieldset
				class="mb-0 mt-4 py-0 px-2 w-full md:w-1/2"
				:class="gridFieldClasses"
				:key="`form-field-${i}-${field.name}`"
				v-for="(field, i) in fields"
			>
				<div class="field" :class="`mg-field-type-${field.component}`">
					<label class="label">{{ fieldLabel(field) | labelised }}</label>
					<div class="control">
						<component class="input" :is="field.component" :form-mode="mode" v-bind="field.props || []" v-model="field.value"></component>
					</div>
					<ul
						class="validation-error p-2 bg-red-600 text-white br-4 mt-1"
						v-if="errors[field.name]"
					>
						<li
							:key="`validation-error-${i}-${index}-${field.name}`"
							v-for="(error, index) in errors[field.name]"
						>{{ error }}</li>
					</ul>
				</div>
			</fieldset>
		</div>
		<slot name="form-button" v-bind="{submitting, onFormSubmitted}">
			<div class="field is-grouped">
				<div class="control">
					<base-button :disabled="submitting">Save</base-button>
				</div>
			</div>
		</slot>
	</form>
</template>
<script>
/** @format */
import {createNamespacedHelpers} from 'vuex';

const {mapGetters} = createNamespacedHelpers('validation');

export default {
	name: 'BaseForm',
	props: {
		formData: {
			type: Array,
			required: true
		},
		editRecord: {
			type: Object,
			required: false
		},
		fieldsInRow: {
			type: Number,
			default: 1
		}
	},
	methods: {
		fieldLabel(field) {
			if (field.label) return field.label;
			return field.name;
		},
		onFormSubmitted() {
			this.submitting = true;
			this.$emit('submitted', this.payload);
		},
		resetFieldValues() {
			this.fields.map((f) => (f.value = ''));
		},
		cancelSubmit() {
			this.submitting = false;
		}
	},
	computed: {
		...mapGetters(['errors']),
		payload() {
			const payload = {};
			for (let i = 0; i < this.fields.length; i++) {
				const field = this.fields[i];
				payload[field.name] = field.value;
			}
			return payload;
		},
		gridRows() {
			return this.fields;
			//return this.fields.chunk(this.fieldsInRow);
			//if (this.fieldsInRow === 1) return this.fields;
		},
		gridFieldClasses() {
			const classes = {};
			classes[`lg:w-1/${this.fieldsInRow}`] = true;
			return classes;
		}
	},
	beforeMount() {
		for (let i = 0; i < this.fields.length; i++) {
			if (!this.fields[i].value) {
				this.$set(this.fields[i], 'value', '');
			}
			if (this.editRecord) {
				if (typeof this.editRecord[this.fields[i].name] == 'boolean') {
					this.fields[i].value = this.editRecord[this.fields[i].name];
				} else {
					this.fields[i].value = this.editRecord[this.fields[i].name];
				}
				this.mode = 'edit';
			}
		}
	},
	data() {
		return {
			submitting: false,
			mode: 'create',
			fields: this.formData
		};
	}
};
</script>
<style lang="scss">
.mg-field-type-base-boolean{
	label {
		margin-bottom:2px!important;
	}
	.control {
		.input {
			background: none;
			border: none;
			padding: 0;
			margin: 0;
			height: auto;
			box-shadow: none;
		}
	}
}
.validation-error {
	li {
		font-size: 0.8rem;
	}
}
</style>
